import * as R from "ramda";
export const userFormModel = {
  first_name: "",
  middle_name: "",
  last_name: "",
  known_as: "",
  username: "",
  email: "",
  password: "",
  birth_date: "2017-05-24",
  birth_place: "",
  homebase_one: "",
  homebase_two: "",
  gender: "Male",
  address: "",
  phone: "",
  cell_phone: "",
  nationality: "",
  role: "user",
  DOB_isUpdated: false,
  nationality_isUpdated: false,
};

export const remUserData = R.pick([
  "first_name",
  "middle_name",
  "last_name",
  "known_as",
  "username",
  "email",
  "password",
  "birth_date",
  "birth_place",
  "homebase_one",
  "gender",
  "address",
  "homebase_two",
  "phone",
  "cell_phone",
  "nationality",
  "role",
  "DOB_isUpdated",
  "nationality_isUpdated",
]);
export const remUserDataCreate = R.pick([
  "first_name",
  "middle_name",
  "last_name",
  "known_as",
  "username",
  "email",
  "password",
  "birth_date",
  "birth_place",
  "homebase_one",
  "homebase_two",
  "gender",
  "address",
  "phone",
  "cell_phone",
  "nationality",
  "role",
  "DOB_isUpdated",
  "nationality_isUpdated",
]);

export const userGeneralForm = {
  first_name: "",
  middle_name: "",
  last_name: "",
  known_as: "",
  username: "",
  email: "",
  password: "",
  birth_date: new Date(),
  birth_place: "",
  homebase_one: "",
  gender: "",
  address: "",
  homebase_two: "",
  DOB_isUpdated: false,
  nationality_isUpdated: false,
};
